/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import './roomspage.css';
import { useParams } from 'react-router';
import { getRoomv2 } from '@/app/services/rooms/rooms';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import RoomStudents from './RoomStudents';
import Feeds from './feeds';
import Pusher from 'pusher-js';

const Room = () => {
	const [activeTab, setActiveTab] = useState(0);
	const [loading, setLoading] = useState(true);
	// room usestate
	const [room, setRoom] = useState({});
	// get id from useparams hook
	const { id } = useParams();
	const user = useSelector(({ auth }) => auth.user);

	useEffect(() => {
		let isMounted = true;

		const pusher = new Pusher(import.meta.env.VITE_PUSHER_CHANNEL_ID, {
			cluster: import.meta.env.VITE_PUSHER_CLUSTER_ID,
			forceTLS: true,
		});
		const channel = pusher.subscribe(
			`ld-channel-${
				user.role[0] === 'school_admin' || user.role[0] === 'sub_admin' ? user.data.school.id : user.school?.id
			}`,
		);

		channel.bind('ld-room-ratio-update-event', () => {
			if (isMounted)
				getRoomv2('', '', id).then((res) => {
					if (isMounted) {
						setRoom(res.data);
					}
				});
		});

		return () => {
			isMounted = false;
			pusher.disconnect();
		};
	}, [user]);

	useEffect(() => {
		let isMounted = true;

		setLoading(true);
		getRoomv2('', '', id).then((res) => {
			if (!isMounted) return;
			setRoom(res.data);
			setLoading(false);
		});

		return () => {
			isMounted = false;
		};
	}, [id]);
	return (
		<>
			<div className="top-bar">
				<div className="flex mx-auto" style={{ gap: 20 }}>
					<span
						className="cursor-pointer personal-hd  font-semibold text-1xl mr-30 ml-40"
						onClick={() => setActiveTab(0)}
					>
						<h1 className={`${activeTab === 0 ? 'active-room-hd' : ''} room-hd`}>Students</h1>
					</span>
					<span className="cursor-pointer personal-hd text-1xl font-semibold" onClick={() => setActiveTab(1)}>
						<h1 className={`${activeTab === 1 ? 'active-room-hd' : ''} room-hd`}>Feeds</h1>
					</span>
				</div>
			</div>
			{loading ? (
				<div className="flex justify-center items-center h-96">
					<CircularProgress size={35} />
				</div>
			) : null}
			{!loading ? activeTab ? <Feeds room={room} /> : <RoomStudents room={room} /> : ''}
		</>
	);
};

export default Room;
